import { isEvaluateInputColumn } from "../evaluate-drawer-utils";

import InputSetsControl from "./InputSetsControl";
import VariableMappingsControl from "./VariableMappingsControl";

import type { VariableSet } from "@/components/Playground/types";
import type { PlaygroundEvaluateSheetReference } from "@/queries/playground/evaluate";

interface EvaluateInputConfigurationProps {
  variableSets: VariableSet[];
  variableNames: string[];
  reference: PlaygroundEvaluateSheetReference;
  mappedColumnIds: string[];
  hasDuplicateMappings: boolean;
  unresolvedVariableNames: string[];
  sourceRowCount: number;
  disabled: boolean;
  onConfigureInputSet: (setId?: string) => void;
}

const EvaluateInputConfiguration = ({
  variableSets,
  variableNames,
  reference,
  mappedColumnIds,
  hasDuplicateMappings,
  unresolvedVariableNames,
  sourceRowCount,
  disabled,
  onConfigureInputSet,
}: EvaluateInputConfigurationProps) => {
  const mappableColumnIds = new Set(
    reference.columns.filter(isEvaluateInputColumn).map(column => column.id),
  );
  const mappedVariableKeys = variableNames.filter(variable =>
    mappableColumnIds.has(reference.input_variable_mappings[variable]?.column_id || ""),
  );

  return (
    <>
      <InputSetsControl
        variableSets={variableSets}
        variableNames={variableNames}
        mappedVariableKeys={mappedVariableKeys}
        reference={reference}
        sourceRowCount={sourceRowCount}
        disabled={disabled}
        onConfigureInputSet={onConfigureInputSet}
      />
      <VariableMappingsControl
        variableNames={variableNames}
        reference={reference}
        mappedColumnIds={mappedColumnIds}
        hasDuplicateMappings={hasDuplicateMappings}
        unresolvedVariableNames={unresolvedVariableNames}
        disabled={disabled}
      />
    </>
  );
};

export default EvaluateInputConfiguration;
